<template>
    <mag-sidebar
        :menu="menu"
        :collapsed="collapse"
        :loggedIn="loggedIn"
        :closeAllItems="closeAll"
        :hasProjectMenu="false"
        title="Contact Centre"
        projectRootFolder=""
        arrowDownClass="icon--arrow-down"
        arrowRightClass="icon--arrow-right"
        logoutIconClass="icon--power-off" 
        myProfileIconClass="icon--walk"
        @collapseChange="collapseChange()"
        @itemWithLinkClick="doNavigation($event)"
        @subItemClick="doNavigation($event)"/>
</template>

<script>

import {mapState, mapGetters} from 'vuex';

export default {
    name: "Sidebar",
    props: {
        collapse: {
            type: Boolean,
            default: true
        },
        closeAll: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {}
    },
    computed: {
        ...mapState({
            loggedIn: state => state.auth.loggedIn
        }),
        ...mapGetters(
            { 
                userCanViewBookings: 'auth/userCanViewBookings', 
                userCanCreateBookings: 'auth/userCanCreateBookings' 
            }
        ),
        menu(){
            return [
                {
                    id: 1,
                    href: '/',
                    title: 'Search bookings',
                    icon: 'icon--search',
                    name: 'search',
                    hidden: !this.userCanViewBookings
                },
                {
                    id: 2,
                    href: '/booking/create',
                    title: 'Create parking booking',
                    icon: 'icon--car',
                    name: 'create-parking-booking',
                    hidden: !this.userCanCreateBookings
                },
                {
                    id: 3,
                    href: '/booking/createlounge',
                    title: 'Create lounge booking',
                    icon: 'icon--spoon-knife',
                    name: 'create-lounge-booking',
                    hidden: !this.userCanCreateBookings
                },
                {
                    id: 4,
                    href: '/booking/createfasttrack',
                    title: 'Create FastTrack booking',
                    icon: 'icon--angle-double-right',
                    name: 'create-fasttrack-booking',
                    hidden: !this.userCanCreateBookings
                }
            ]
        }
    },
    methods: {
        collapseChange(){
            this.$emit('collapseChange', this.isCollapsed);
        },
        doNavigation(e){
            this.nav(e);
        },
        nav: function (path) {
            this.$router.push(path);
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
    // TODO - fix font alignment in icoMoon - icon for power-off doesn't align with rest of icons, so added temp fix
    /deep/ .sidebar__icon {
        top: 2px;
        left: 2px;
        width: 20px;
        font-size: 16px;
        display: inline-block;
    }
    /deep/ .sidebar__icon.icon--search {
        left: 2px;
        font-size: 18px;
        line-height: 18px;
    }
    /deep/ .sidebar__icon.icon--car {
        left: 2px;
        font-size: 16px;
        line-height: 16px;
    }
    /deep/ .sidebar__icon.icon--spoon-knife {
        left: 3px;
        font-size: 18px;
        line-height: 16px;
    }
    /deep/ .sidebar__icon.icon--angle-double-right {
        left: 3px;
        font-size: 24px;
        line-height: 16px;
    }
    /deep/ .sidebar__icon.icon--power-off {
        left: 4px;
    }
</style>
